import { render } from "./errors.vue?vue&type=template&id=24a01928&ts=true"
import script from "./errors.vue?vue&type=script&lang=ts"
export * from "./errors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__